/* global __webpack_require__ */
// patch for dynamic imports

const hasProtocol = (host) => /^http/i.test(host);

if (MOVE_DATA.assetHost) {
  // patch for sandboxes
  let protocol = window.location.protocol,
      assetHost = hasProtocol(MOVE_DATA.assetHost) ? MOVE_DATA.assetHost : `${protocol}//${MOVE_DATA.assetHost}`,
      assetPath = __webpack_require__.p;
  __webpack_require__.p = assetHost + assetPath;
}



// WEBPACK FOOTER //
// /data/app/rdc-next/app/javascript/packs/set-public-path.js